import Vue from "vue";

Vue.directive('toggle-basket-preview', {

    bind(el) {
        el.onclick = function() {

            $('.basket-preview').toggleClass('basket-preview--open');
            $('body').toggleClass('basket-preview--visible');
            $('.shop-nav__btn-basket-preview').toggleClass('shop-nav__btn--close');

            if($(document).outerWidth() >= 992) {

                let $btn = $('.shop-nav__search-btn');

                $('.search__wrapper').slideUp(200);
                $btn.removeClass('shop-nav__btn--close');

                setTimeout(function () {
                    $('.search__input').blur();
                }, 200);
            }

        };
    },
});
